import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./Redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import LogRocket from "logrocket";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";

if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  process.env.REACT_APP_SENTRY_KEY
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_STAGING
  });
}

ReactDOM.render(
  <ErrorBoundary
    onClick={() => {
      localStorage.clear();
      window.location.reload();
    }}
    handleComponentDidCatch={(error) => {
      LogRocket.captureMessage(error.message, {
        tags: {
          userType: "support"
        },
        extra: {
          fatal: true,
          code: error.code
        }
      });
    }}
  >
    <React.StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
  // serviceWorkerRegistration.unregister();
}

if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate: onSWUpdate,
    onSuccess: (_controller, buildNo) => {
      console.warn(`Successfully updated and serving build ${buildNo}`);
    }
  });
} else {
  serviceWorkerRegistration.unregister();
}

navigator.serviceWorker?.addEventListener("message", (event) => {
  if (event.data === "FORCE_UPDATE_COMPLETE") {
    window.location.reload(true);
  }
});

const skipWaitingClearCacheAndReload = async () => {
  navigator.serviceWorker?.ready.then((registration) => {
    registration.waiting.postMessage("FORCE_UPDATE");
  });
};

async function onSWUpdate(controller, _force) {
  if (controller) {
    const criticalUpdateCard = document.getElementById("critical-update-card");
    criticalUpdateCard.classList.remove("display-none");
    criticalUpdateCard.classList.add("display-block");
    const criticalUpdateButton = document.getElementById(
      "critical-update-confirm-button"
    );
    criticalUpdateButton.addEventListener("click", () => {
      skipWaitingClearCacheAndReload();
    });
  }
}

reportWebVitals();
